import React from "react";
import Router from "./routes/Router";
import WithAuthentication from "./context/Authentication/WithAuthentication.tsx";
import WithWebInfo from "./context/WebInfo/WithWebInfo.tsx";

import { Toaster } from "react-hot-toast";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";
import { CardItemContextProvider } from "./context/CardItem/CardItemContext";
import { ManagementContextProvider } from "./context/AdminManagement/ManagementContext.jsx";
import { ProductContextProvider } from "context/ProductContext/ProductDataContext";

export default function App() {
  return (
    <div>
      <Tooltip style={{ zIndex: "10" }} id="my-tooltip" />
      {/* <WithAuthentication> */}
      {/* <WithWebInfo> */}
      {/* <ProductContextProvider> */}
      {/* <CardItemContextProvider> */}
      {/* <ManagementContextProvider> */}
      {/* <Toaster /> */}
      <Router />
      {/* </ManagementContextProvider> */}
      {/* </CardItemContextProvider> */}
      {/* </ProductContextProvider> */}
      {/* </WithWebInfo> */}
      {/* </WithAuthentication> */}
    </div>
  );
}
